import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const Caption = ({ label = '', onChange = () => {} }) => {
  const [editMode, setEditMode] = useState(false);
  const [captionLabel, setCaptionLabel] = useState(label);
  const inputRef = useRef(null);

  const inputStyle = {
    boxShadow: 'none',
    backgroundColor: 'transparent',
    outline: 'none',
    width: '100%',
    border: 'none',
    padding: '0px',
  };

  const handleEdit = event => {
    event.stopPropagation();

    if (editMode) {
      setEditMode(false);
      return;
    }

    setEditMode(true);
    setTimeout(() => {
      inputRef.current.select();
    }, 10);
  };

  const handleInputBlur = () => {
    // setEditMode(false);
  };

  const handleInputChange = event => {
    setCaptionLabel(event.target.value);
  };

  const handleInputClick = event => {
    event.stopPropagation();
  };

  const handleInputKeyPress = event => {
    if (event.key === 'Enter') {
      setEditMode(false);
    }
  };

  useEffect(() => {
    if (editMode === false) {
      if (captionLabel !== label) {
        onChange(captionLabel);
      }
    }
  }, [editMode]);

  return (
    <div className="caption">
      {editMode ? (
        <input
          type="text"
          ref={inputRef}
          style={inputStyle}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
          onClick={handleInputClick}
          onKeyPress={handleInputKeyPress}
          value={captionLabel}
          autoFocus // eslint-disable-line
        />
      ) : (
        captionLabel
      )}
      <div className="edit-button" onClick={handleEdit}>
        {editMode ? <i className="fas fa-check" /> : <i className="fas fa-pen" />}
      </div>
    </div>
  );
};

Caption.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
};

export default Caption;
